/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HomeownershipTermsLender } from './HomeownershipTermsLender';
import {
    HomeownershipTermsLenderFromJSON,
    HomeownershipTermsLenderFromJSONTyped,
    HomeownershipTermsLenderToJSON,
} from './HomeownershipTermsLender';

/**
 * The home and who is running the program for its owner. Empty config values come back null.
 * @export
 * @interface HomeownershipHomeBlock
 */
export interface HomeownershipHomeBlock {
    /**
     * 
     * @type {string}
     * @memberof HomeownershipHomeBlock
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipHomeBlock
     */
    photoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipHomeBlock
     */
    brandName?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipHomeBlock
     */
    brandLogoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipHomeBlock
     */
    brandColor?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipHomeBlock
     */
    supportEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipHomeBlock
     */
    advisorPhone?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipHomeBlock
     */
    lenderLink?: string;
    /**
     * 
     * @type {Array<HomeownershipTermsLender>}
     * @memberof HomeownershipHomeBlock
     */
    lenders?: Array<HomeownershipTermsLender>;
    /**
     * 
     * @type {boolean}
     * @memberof HomeownershipHomeBlock
     */
    mainstayAgentOptionEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipHomeBlock
     */
    consentText: string;
    /**
     * 
     * @type {number}
     * @memberof HomeownershipHomeBlock
     */
    bedrooms?: number;
    /**
     * 
     * @type {number}
     * @memberof HomeownershipHomeBlock
     */
    bathrooms?: number;
    /**
     * 
     * @type {number}
     * @memberof HomeownershipHomeBlock
     */
    livingSqft?: number;
    /**
     * 
     * @type {number}
     * @memberof HomeownershipHomeBlock
     */
    yearBuilt?: number;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipHomeBlock
     */
    leaseEndDate?: string;
}

/**
 * Check if a given object implements the HomeownershipHomeBlock interface.
 */
export function instanceOfHomeownershipHomeBlock(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mainstayAgentOptionEnabled" in value;
    isInstance = isInstance && "consentText" in value;

    return isInstance;
}

export function HomeownershipHomeBlockFromJSON(json: any): HomeownershipHomeBlock {
    return HomeownershipHomeBlockFromJSONTyped(json, false);
}

export function HomeownershipHomeBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipHomeBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': !exists(json, 'address') ? undefined : json['address'],
        'photoUrl': !exists(json, 'photo_url') ? undefined : json['photo_url'],
        'brandName': !exists(json, 'brand_name') ? undefined : json['brand_name'],
        'brandLogoUrl': !exists(json, 'brand_logo_url') ? undefined : json['brand_logo_url'],
        'brandColor': !exists(json, 'brand_color') ? undefined : json['brand_color'],
        'supportEmail': !exists(json, 'support_email') ? undefined : json['support_email'],
        'advisorPhone': !exists(json, 'advisor_phone') ? undefined : json['advisor_phone'],
        'lenderLink': !exists(json, 'lender_link') ? undefined : json['lender_link'],
        'lenders': !exists(json, 'lenders') ? undefined : ((json['lenders'] as Array<any>).map(HomeownershipTermsLenderFromJSON)),
        'mainstayAgentOptionEnabled': json['mainstay_agent_option_enabled'],
        'consentText': json['consent_text'],
        'bedrooms': !exists(json, 'bedrooms') ? undefined : json['bedrooms'],
        'bathrooms': !exists(json, 'bathrooms') ? undefined : json['bathrooms'],
        'livingSqft': !exists(json, 'living_sqft') ? undefined : json['living_sqft'],
        'yearBuilt': !exists(json, 'year_built') ? undefined : json['year_built'],
        'leaseEndDate': !exists(json, 'lease_end_date') ? undefined : json['lease_end_date'],
    };
}

export function HomeownershipHomeBlockToJSON(value?: HomeownershipHomeBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
        'photo_url': value.photoUrl,
        'brand_name': value.brandName,
        'brand_logo_url': value.brandLogoUrl,
        'brand_color': value.brandColor,
        'support_email': value.supportEmail,
        'advisor_phone': value.advisorPhone,
        'lender_link': value.lenderLink,
        'lenders': value.lenders === undefined ? undefined : ((value.lenders as Array<any>).map(HomeownershipTermsLenderToJSON)),
        'mainstay_agent_option_enabled': value.mainstayAgentOptionEnabled,
        'consent_text': value.consentText,
        'bedrooms': value.bedrooms,
        'bathrooms': value.bathrooms,
        'living_sqft': value.livingSqft,
        'year_built': value.yearBuilt,
        'lease_end_date': value.leaseEndDate,
    };
}

